export default function userModel() {
    return {
        firstName: '',
        lastName: '',
        birthDate: '',
        mail: '',
        isPorting: true,
        phonenumberToPort: '',
        codeSend: false,
        isPortValid: false,
        id: '',
        code: '',
        startDate: '',
        identifier: {},
    };
}
